module.exports = __webpack_public_path__ + "img/fbs_image_2.5f7337b7.jpg";